/**
 * Map inspection bboxes onto a video/image element that uses object-fit.
 * @param {'cover'|'contain'} fit
 */
export function getObjectFitMapping(media, container, fit = 'cover') {
  if (!media || !container) return null;
  const vw = media.videoWidth || media.naturalWidth;
  const vh = media.videoHeight || media.naturalHeight;
  if (!vw || !vh) return null;

  const rect = container.getBoundingClientRect();
  const ew = rect.width;
  const eh = rect.height;
  if (!ew || !eh) return null;

  const scale =
    fit === 'contain' ? Math.min(ew / vw, eh / vh) : Math.max(ew / vw, eh / vh);
  const dw = vw * scale;
  const dh = vh * scale;
  const ox = (ew - dw) / 2;
  const oy = (eh - dh) / 2;

  return { vw, vh, ew, eh, scale, dw, dh, ox, oy, fit };
}

/** @deprecated use getObjectFitMapping(..., 'cover') */
export function getCoverMapping(video, container) {
  return getObjectFitMapping(video, container, 'cover');
}

export function getContainMapping(media, container) {
  return getObjectFitMapping(media, container, 'contain');
}

/** norm = { nx, ny, nw, nh } in 0..1 of full video frame */
export function normToContainerPercent(norm, mapping) {
  if (!mapping || !norm) return null;
  const { ew, eh, dw, dh, ox, oy } = mapping;
  return {
    left: ((ox + norm.nx * dw) / ew) * 100,
    top: ((oy + norm.ny * dh) / eh) * 100,
    width: ((norm.nw * dw) / ew) * 100,
    height: ((norm.nh * dh) / eh) * 100,
  };
}

/** Center ROI guide (fill 0..1 of full frame) → container % */
export function centerRoiToContainerPercent(fill, mapping) {
  if (!mapping) return null;
  const pad = (1 - fill) / 2;
  return normToContainerPercent(
    { nx: pad, ny: pad, nw: fill, nh: fill },
    mapping
  );
}
